/**
 * Normalize an email for Supabase OTP. `signInWithOtp` and `verifyOtp` must
 * receive the IDENTICAL string or verification fails, so this is the single
 * source of truth. Strips whitespace + zero-width chars and lowercases.
 */
export function normalizeEmail(raw: string): string {
  return raw.replace(/[\s​-‍﻿]+/g, '').toLowerCase();
}

const INVALID_CODE = 'That code is invalid or expired — check it or resend.';
const INVALID_EMAIL = "That email doesn't look right — check it and try again.";
const RATE_LIMITED = 'Too many attempts — wait a minute and try again.';
const GENERIC = 'Something went wrong — please try again.';

/**
 * Map a Supabase auth error to friendly, non-leaking copy. `step` matters
 * because the same substrings mean different things: on the email step an
 * "invalid format" error is about the address, not a 6-digit code the user
 * was never sent.
 */
export function mapAuthError(err: unknown, step: 'email' | 'code' = 'code'): string {
  const message =
    typeof err === 'object' && err !== null && 'message' in err
      ? String((err as { message: unknown }).message)
      : '';
  const lower = message.toLowerCase();
  if (lower.includes('rate limit')) return RATE_LIMITED;
  if (lower.includes('invalid') || lower.includes('expired')) {
    return step === 'email' ? INVALID_EMAIL : INVALID_CODE;
  }
  return GENERIC;
}
